import { useContext, useEffect, useState } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import { Button, Card, Col, Form, Image, Modal, Row, Tabs, Tab } from "react-bootstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { Field, Formik } from "formik"
import Post from '../../../api/Post'
import Get from '../../../api/Get'
import { 
    ACCOUNT_CONF_MESSAGES_GET_BY_ID,
    ACCOUNT_CONF_MESSAGES_SAVE,
    ACCOUNT_CONF_MESSAGES_UPDATE,
    ACCOUNT_GET,
    FIELDS_GET,
} from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import LoadingList from "../../../loader/LoadingList";
import { withTranslation } from "react-i18next";
import ComponentModalErrorSever from "../../../components/ComponentModalErrorSever";
import iconRecheck from '../../../img/icons/recheck.svg'
import Put from "../../../api/Put";
import { UploadImage } from "../../../components/doctor/UploadImage";
import { isBase64 } from "../../../utils/isBase64";



function ConfCuenta({t}){
    const { auth } = useContext(authContext)
    const history = useHistory();
    const {id} = useParams();
    const [loading, setLoading] = useState(false)
    const [account, setAccount] = useState(null)
    const [fieldOpt, setFieldOpt] = useState([])
    const [initialValues, setInitialValues] = useState({
        id: null,
        approvedServiceText: '',
        informationPatientStep1: '',
        informationTelemedicine: '',
        informedConsent: '',
        urlImage: '',
        colorFont:'',
        paymentText: '',
        account: {id: id},
        informedConsentOffice: ''
    })  
    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }
    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => setShowSuccess(false);

    useEffect(() => {
        setLoading(true)
        async function getCuenta(){
            try {
                const response = await Get({url: `${ACCOUNT_GET}/${id}`, access_token: auth.data.access_token})
                setAccount(response.data.data)
                setLoading(false)
            } catch (error) {
                setAccount(null)
                setLoading(false)
            }           
        }
        getCuenta();
    }, [])

    useEffect(() => {
        async function getFields(){
            const response = await Get({url: `${ACCOUNT_CONF_MESSAGES_GET_BY_ID}/${id}`, access_token: auth.data.access_token})
            console.log(response)
            setInitialValues({
                id:response.data.data?.id || null,
                approvedServiceText: response.data.data?.approvedServiceText || '',
                informationPatientStep1: response.data.data?.informationPatientStep1 || '',
                informationTelemedicine: response.data.data?.informationTelemedicine || '',
                informedConsent: response.data.data?.informedConsent || '',
                url_photo: response.data.data?.url_photo || '',
                colorFont: response.data.data?.colorFont || '',
                fontSize: response.data.data?.fontSize || '',
                urlImage: response.data.data?.urlImage || null,
                paymentText: response.data.data?.paymentText || '',
                account: {id: id},
                informedConsentOffice: response.data.data?.informedConsentOffice || '',
            })
        }
        getFields();
    }, [])
    
    useEffect(() => {
        async function getFieldsOpt(){
            const response = await Get({url: `${FIELDS_GET}/`, access_token: auth.data.access_token})
            setFieldOpt(response.data.data.response)
        }
        getFieldsOpt();
    }, [])

    return( <>
        { 
            loading ? <LoadingList texto='' /> : <>

            <div className="body">
                <Row className="align-items-center">
                    <Col xs="12" md="8">
                        {account && <h2 className="mb-0 title-top">{`Cuenta ${account?.name}` }</h2>}
                    </Col>
                    <Col xs="12" md="4" className="text-right">
                        <IoIosCloseCircle className="cancel-btn" onClick={e=>history.goBack()}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Formik 
                            initialValues={ initialValues }
                            enableReinitialize
                            onSubmit={async (values, { setSubmitting, setFieldValue }) => { 
                                console.log(values)
                                if(!isBase64(values.url_photo)){
                                    values.url_photo = ""
                                }
                                try {
                                    let response;
                                    if(values.id){
                                        response = await Put({url: ACCOUNT_CONF_MESSAGES_UPDATE, data: values, header:true, access_token:   auth.data.access_token})
                                    }else{
                                        response = await Post({url: ACCOUNT_CONF_MESSAGES_SAVE, data: values, header:true, access_token:   auth.data.access_token})
                                    }
                                    console.log(response)
                                    if(response.data.state){
                                        setSubmitting(false) 
                                        setShowSuccess(true)
                                        setTimeout(()=>{
                                            setShowSuccess(false)
                                            history.goBack();
                                        }, 2000)
                                    }
                                } catch (error) {
                                        setSubmitting(false)  
                                        setShowModalServer(true)
                                        if(error.response){
                                            setErrorServer(error.response)
                                        } 
                                }
                            }}
                        >{({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                        }) => (
                            <Form onSubmit={handleSubmit}  className='mt-3'>
                                {isSubmitting && <LoadingList texto="Procesando información" />}
                                <Card className="shadow-1 formSection">
                                    <Card.Body>
                                        <Row className="mb-3">
                                            <Col>
                                                <h5>Configurar cuenta</h5>
                                            </Col>
                                        </Row>
                                        <Tabs defaultActiveKey="general" className="tabs-conference" transition={false}>
                                            <Tab eventKey="general" title='General'>
                                                <Row className="mt-4">
                                                    <Col xs="12" md="4">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Tamaño de letra</Form.Label>
                                                            <Field
                                                                className={`form-control input-form ${errors.fontSize && 'error'}`}
                                                                name="fontSize"
                                                                type="number"
                                                            />
                                                            <span className="text-muted">Formato en px ejemplo 10</span>
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="12" md="4">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Color de letra</Form.Label>
                                                            <Field
                                                                className={`form-control input-form ${errors.colorFont && 'error'}`}
                                                                name="colorFont"
                                                            />
                                                            <span className="text-muted">Formato en hexadecimal ejemplo #fff</span>
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                <Col xs="6" md="6" className="mt-2">
                                                    <UploadImage title='Imagen' 
                                                        imageDefault={values?.url_photo}
                                                        field='url_photo' 
                                                        setFieldValue={ setFieldValue } 
                                                    />
                                                    {
                                                        values.urlImage && 
                                                        <div className="mt-2">
                                                            <Image src={values.urlImage} fluid />
                                                        </div>
                                                    }
                                                </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="paso1" title='Paso 1'>
                                                <Row className="mt-4">
                                                    <Col xs="12" md="6">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Información del paciente Paso 1</Form.Label>
                                                            <Field
                                                                className={`form-control ${errors.informationPatientStep1 && 'error'}`}
                                                                as="textarea"
                                                                rows="7"
                                                                name="informationPatientStep1"
                                                            />
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="paso3" title='Paso 3'>
                                                <Row className="mt-4">
                                                    <Col xs="12" md="6">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Mensaje de telemedicina</Form.Label>
                                                            <Field
                                                                className={`form-control ${errors.informationTelemedicine && 'error'}`}
                                                                as="textarea"
                                                                rows="7"
                                                                name="informationTelemedicine"
                                                            />
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="12" md="6">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Mensaje de aprobación</Form.Label>
                                                            <Field
                                                                className={`form-control ${errors.approvedServiceText && 'error'}`}
                                                                as="textarea"
                                                                rows="7"
                                                                name="approvedServiceText"
                                                            />
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="12" md="12">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Consentimiento informado</Form.Label>
                                                            <span className="text-muted d-block">Usar estas etiquetas para cambiar por datos de la cita</span>
                                                            <ul className="mb-1 list-inline">
                                                                <li className="list-inline-item"><span className="badge badge-info">#doctor-nombre</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#doctor-especialidad</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#fecha-actual</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#paciente-nombrecompleto</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#paciente-clientecorporativo</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#paciente-documento-identidad</span></li>
                                                            </ul>
                                                            <Field
                                                                className={`form-control ${errors.informedConsent && 'error'}`}
                                                                as="textarea"
                                                                rows="8"
                                                                name="informedConsent"
                                                            />
                                                            
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs="12" md="12">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Consentimiento informado consultorio</Form.Label>
                                                            <span className="text-muted d-block">Usar estas etiquetas para cambiar por datos de la cita</span>
                                                            <ul className="mb-1 list-inline">
                                                                <li className="list-inline-item"><span className="badge badge-info">#doctor-nombre</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#doctor-especialidad</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#fecha-actual</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#paciente-nombrecompleto</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#paciente-clientecorporativo</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#paciente-documento-identidad</span></li>
                                                            </ul>
                                                            <Field
                                                                className={`form-control ${errors.informedConsentOffice && 'error'}`}
                                                                as="textarea"
                                                                rows="8"
                                                                name="informedConsentOffice"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="copago" title="Copago">
                                                <Row className="mt-4">
                                                    <Col xs="12" md="12">
                                                        <Form.Group>
                                                            <Form.Label className="font-weight-bold-600 text-secondary">Mensaje de copago</Form.Label>
                                                            <span className="text-muted d-block">Usar estas etiquetas para cambiar por datos de la cita</span>
                                                            <ul className="mb-1 list-inline">
                                                                <li className="list-inline-item"><span className="badge badge-info">#importe-copago</span></li>
                                                                <li className="list-inline-item"><span className="badge badge-info">#moneda-copago</span></li>
                                                            </ul>
                                                            <Field
                                                                className={`form-control ${errors.paymentText && 'error'}`}
                                                                as="textarea"
                                                                rows="8"
                                                                name="paymentText"
                                                            />
                                                            
                                                            {/* { errors.titular?.documentNumber && <div className="invalid-feedback d-block">{errors.titular?.documentNumber}</div> } */}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                        </Tabs>
                                                                            
                                    </Card.Body>
                                </Card>
                                

                                <Row className="grupoBotones">
                                <Col className="text-right">
                                    <Link to="/admin/cuentas" className="btn btn-danger cancelar-buttom">Cancelar</Link>{' '}
                                    <Button variant="outline-success" className="ok-buttom" type="submit">{`Aceptar`}</Button>{' '}
                                </Col>
                            </Row>
                            </Form>
                        )}</Formik>
                    </Col>
                </Row>
            </div></>
        }

        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
        <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
            <Modal.Body className="p-0">
                <div className="text-center position-relative overflow-hidden h-100p">
                    <Image src={iconRecheck} fluid className="img-recheck"/>
                    <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                </div>                
            </Modal.Body>
        </Modal>
    </> )
}

export default withTranslation()(ConfCuenta)